"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _simpleBar = _interopRequireDefault(require("./simple-bar"));

var _segmentsUtils = require("./segments-utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SimpleBarPartie = function SimpleBarPartie(props) {
  var partie = props.partie,
      completed = props.completed,
      defaultSegmentColors = props.defaultSegmentColors; // on omet segmentByEvalRange

  var _get_segments_by_eval = (0, _segmentsUtils.get_segments_by_eval)(partie.evaluations, defaultSegmentColors),
      _get_segments_by_eval2 = _slicedToArray(_get_segments_by_eval, 2),
      segmentColorsByEvalRange = _get_segments_by_eval2[1];

  var lowerColor = segmentColorsByEvalRange[0];
  var higherColor = segmentColorsByEvalRange[segmentColorsByEvalRange.length - 1];
  return _react["default"].createElement("div", {
    className: "container-partie",
    style: {
      display: "flex"
    }
  }, _react["default"].createElement("div", {
    className: "col-eval-partie",
    style: {
      width: "100%"
    }
  }, _react["default"].createElement("h4", null, partie.label), _react["default"].createElement("div", {
    className: "score"
  }, "Score: ", partie.percent, "%"), _react["default"].createElement(_simpleBar["default"], {
    score: partie.percent,
    bg: lowerColor,
    bar: higherColor
  }), completed && _react["default"].createElement("div", {
    className: "evaluation-partie",
    dangerouslySetInnerHTML: {
      __html: partie.evaluation.reco
    }
  })));
};

var _default = SimpleBarPartie;
exports["default"] = _default;